export default __webpack_public_path__ + "static/media/bnr9.d4b3b9b1.jpg";